import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Weekday } from '@chancenwerk/db/enums/enums.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { DateTime } from 'luxon';
import { MarktAkquiseContactRecord } from './MarktAkquiseContactRecord.js';

/**
 * @entity MarktVeranstaltungsAkquiseEntry
 */
@Entity()
export class MarktVeranstaltungsAkquiseEntry extends AdornisEntity {
  public static override _class = 'MarktVeranstaltungsAkquiseEntry';

  public static override resolveID(entity: any): string {
    return entity._id ?? A.getGloballyUniqueID();
  }

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id: Maybe<string>;

  @Field(type => String)
  semester: Maybe<string>;

  @Field(type => String)
  name: Maybe<string>;

  @Field(type => String)
  room: Maybe<string>;

  @Field(type => [String])
  days: Maybe<Weekday[]>;

  @Field(type => DateTime)
  startTime: Maybe<DateTime>;

  @Field(type => DateTime)
  endTime: Maybe<DateTime>;

  @Field(type => DateTime)
  start: Maybe<DateTime>;

  @Field(type => DateTime)
  end: Maybe<DateTime>;

  @Field(type => String)
  contactPersonID: Maybe<string>;

  @DataLoadedField(type => ChancenwerkUser, ({ contactPersonID }) => contactPersonID)
  contactPerson: Maybe<ChancenwerkUser>;

  @Field(type => [MarktAkquiseContactRecord])
  contacts: Maybe<MarktAkquiseContactRecord[]>;

  getLatestStatus() {
    return this.contacts?.at(-1)?.status ?? ('Leer' as string);
  }
}
